import React, { useState, useEffect } from "react";
import { DetailsModal } from "components/grid/DetailsModal";
import ErrorHandler from "components/core/ErrorHandler";

import "font-awesome/css/font-awesome.min.css";

import { useFetchAdminRxDetails } from "./hooks/useFetchAdminRxDetails";
import { useFetchAdminAdditionalRxDetails } from "./hooks/useFetchAdminAdditionalRxDetails";

import RenderDataToGridLayout from "shared/components/renderData/RenderDataToGridLayout";
import DisplayNoDataAvailable from "shared/components/notifications/DisplayNoDataAvailable";
import { ControlSpinner } from "shared/components/spinners/ControlSpinner";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { titleConstants } from "./AdminRxLookupPropertyTitles";

export default function AdminRxLookupDetailPopup(props) {
  const {
    selectedRxNumber,
    selectedClaimId,
    selectedPaymentId,
    show,
    onClose,
  } = props;

  const [error, setError] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);

  let detailsApiParameters = {
    user: "not used",
    claimId: selectedClaimId,
    paymentId: selectedPaymentId,
  };

  useEffect(() => {
    //make3 sure first tab is selected when the modal is first shown
    if (show) setSelectedTab(0);
  }, [show]);

  var { data: rxDetailsData, isLoading: rxDetailsLoading } =
    useFetchAdminRxDetails(detailsApiParameters);

  let additionalDetailsApiParameters = {
    claimId: selectedClaimId,
  };

  var {
    data: rxDetailsAdditionalData,
    isLoading: rxDetailsAdditionalDataLoading,
  } = useFetchAdminAdditionalRxDetails(additionalDetailsApiParameters);

  const handleTabSelect = (e) => {
    setSelectedTab(e.selected);
  };

  //BU requested a specific format for dayssupply and quantity, did it here and at the grid level
  function FormatRxDetailsData(data) {
    // make a copy of the data so we don't modify the original
    let newData = { ...data };

    // format daysSupply as a 2 digit decimal
    if (newData.daysSupply && !isNaN(newData.daysSupply)) {
      newData.daysSupply = data.daysSupply.toFixed(2);
    }

    // format quantity as a 3 digit decimal
    if (newData.quantity && !isNaN(newData.quantity)) {
      newData.quantity = data.quantity.toFixed(3);
    }

    //NOTE: For properties in newData, use titleConstants to get the display name and replace the original value
    for (const key in newData) {
      if (titleConstants[key]) {
        newData[titleConstants[key]] = newData[key];
        delete newData[key];
      }
    }

    return newData;
  }

  return (
    <DetailsModal
      // overrideClass="grid-details-modal2"
      title={`Rx ${selectedRxNumber}`}
      show={show}
      handleClose={onClose}
    >
      {(rxDetailsLoading || rxDetailsAdditionalDataLoading) && (
        <ControlSpinner />
      )}
      <ErrorHandler
        error={error}
        onClose={() => {
          setError({});
        }}
      />

      <div className="fee-and-adjustment-detail-summary-wrapper">
        <br />
        {(rxDetailsData && (
          <TabStrip selected={selectedTab} onSelect={handleTabSelect}>
            <TabStripTab title="Details">
              {rxDetailsData ? (
                <RenderDataToGridLayout
                  data={FormatRxDetailsData(rxDetailsData)}
                />
              ) : (
                <DisplayNoDataAvailable />
              )}
            </TabStripTab>
            <TabStripTab title="Additional Details">
              {rxDetailsAdditionalData ? (
                <RenderDataToGridLayout data={rxDetailsAdditionalData} />
              ) : (
                <DisplayNoDataAvailable />
              )}
            </TabStripTab>
          </TabStrip>
        )) ||
          (!rxDetailsLoading && <DisplayNoDataAvailable />)}{" "}
        {/* if no rxDetailsData is available after making call, show the no data available message */}
      </div>
    </DetailsModal>
  );
}
